export type WizardStep = {
  StepNumber: number;
  StepComponent: React.ReactNode;
};

export type WizardStepViewerProps = {
  CurrentStep: number;
  Steps: WizardStep[];
};

export const WizardStepViewer: React.FC<WizardStepViewerProps> = (props) => {
  return <>{props.Steps.find((step) => step.StepNumber === props.CurrentStep)?.StepComponent}</>;
};
